/**
 * Controller de produtos
 */

import { produtoService } from '@services';
import { Produto } from '@types';

export class ProdutoController {
  /**
   * Obtém produtos de uma classificação
   */
  async obterProdutos(
    classificacao: string,
    procurar: string = ''
  ): Promise<Produto[]> {
    try {
      const produtos = await produtoService.obterProdutos(classificacao, procurar);
      return produtos;
    } catch (error: any) {
      console.error('Erro ao obter produtos:', error);
      throw error;
    }
  }

  /**
   * Obtém produtos da previsao ativa do vendedor
   */
  async obterProdutoPrevisaoPedido (
    classificacao: string,
    procurar: string = ''
  ): Promise<Produto[]> {
    try {
      const produtos = await produtoService.obterProdutoPrevisaoPedido(classificacao, procurar);
      return produtos;
    } catch (error: any) {
      console.error('Erro ao obter produtos:', error);
      throw error;
    }
  }

  /**
   * Obtém produto por código
   */
  async obterPorCodigo(
    codigo: string,
    classificacao: string
  ): Promise<Produto | null> {
    try {
      const produto = await produtoService.obterPorCodigo(codigo, classificacao);
      return produto;
    } catch (error: any) {
      console.error('Erro ao obter produto:', error);
      throw error;
    }
  }

  /**
   * Busca produtos
   */
  async buscar(classificacao: string, termo: string): Promise<Produto[]> {
    try {
      const produtos = await produtoService.buscar(classificacao, termo);
      return produtos;
    } catch (error: any) {
      console.error('Erro ao buscar produtos:', error);
      throw error;
    }
  }

  /**
   * Calcula disponibilidade do produto
   */
  calcularDisponibilidade(produto: Produto): number {
    return produtoService.calcularDisponibilidade(produto);
  }

  /**
   * Verifica se produto tem estoque disponível
   */
  hasEstoqueDisponivel(produto: Produto, quantidade: number = 1): boolean {
    return produtoService.hasEstoqueDisponivel(produto, quantidade);
  }

  /**
   * Valida preço do produto
   */
  validarPreco(produto: Produto, preco: number): {
    isValid: boolean;
    message?: string;
  } {
    return produtoService.validarPreco(produto, preco);
  }

  /**
   * Filtra produtos
   */
  filtrarProdutos(produtos: Produto[], termo: string): Produto[] {
    return produtoService.filtrarProdutos(produtos, termo);
  }

  /**
   * Ordena produtos
   */
  ordenarProdutos(
    produtos: Produto[],
    campo: keyof Produto = 'nome',
    ordem: 'asc' | 'desc' = 'asc'
  ): Produto[] {
    return produtoService.ordenarProdutos(produtos, campo, ordem);
  }

  /**
   * Ordena produtos por nome
   */
  ordenarPorNome(produtos: Produto[], ordem: 'asc' | 'desc' = 'asc'): Produto[] {
    const sorted = [...produtos].sort((a, b) => {
      const compare = a.nome.localeCompare(b.nome);
      return ordem === 'asc' ? compare : -compare;
    });
    return sorted;
  }

  /**
   * Ordena produtos por preço
   */
  ordenarPorPreco(produtos: Produto[], ordem: 'asc' | 'desc' = 'asc'): Produto[] {
    const sorted = [...produtos].sort((a, b) => {
      const precoA = parseFloat(a.precoVenda) || 0;
      const precoB = parseFloat(b.precoVenda) || 0;
      const compare = precoA - precoB;
      return ordem === 'asc' ? compare : -compare;
    });
    return sorted;
  }
}

export const produtoController = new ProdutoController();